<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="merge-suggestion-notification">
    <UtdNotification id="mergeSuggestionNotification"
                     notification-mode="info"
                     :has-close-notification="!isEhrUser"
                     @closed="handleClose">
      <template #title>
        {{ notificationTitle }}
      </template>
      <template #default>
        <p class="merge-suggestion-notification__body">
          {{ notificationBody }}
        </p>
      </template>
      <template #listContent>
        <div class="merge-suggestion-notification__actions">
          <UtdButton button-size="small"
                     button-style="clean"
                     @click="navigateToMerge">
            Merge Accounts
          </UtdButton>
        </div>
      </template>
    </UtdNotification>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import UtdNotification from '_acaSrc/components/shared/utd/UtdNotification.vue';
import UtdButton from '_acaSrc/components/shared/stdlib/UtdButton.vue';
import { getWindow } from '_acaSrc/utility/DOM';
import PubSub from '_acaSrc/utility/PubSub';
import { C_EVENTS } from '_acaSrc/utility/constants';

const props = defineProps({
    isVisible: {
        type: Boolean,
        default: false
    },
    isEhrUser: {
        type: Boolean,
        default: false
    }
});

const emit = defineEmits([ 'closed', 'merge-clicked' ]);

const notificationTitle = computed(() => {
    if (props.isEhrUser) {
        return 'Enter another email or merge with your existing account';
    }
    return 'You already have an account with this email';
});

const notificationBody = computed(() => {
    if (props.isEhrUser) {
        return 'Enter a different email to continue registering a new account ' 
        + 'or merge with your existing account to complete registration.';
    }
    return 'Continue registering a new account with this email ' 
        + 'or merge with your existing account to complete registration.';
});

const handleClose = () => {
    emit('closed');
};

const navigateToMerge = () => {
    emit('merge-clicked');
    new PubSub().publish(C_EVENTS.TRACK_UI_CLICK_EVENT, {
        uiElementName: 'mergeSuggestionNotification_mergeAccountsButton',
        targetUrl: '/login-register?openMerge=true'
    });
    getWindow().location.href = '/login-register?openMerge=true';
};
</script>

<style lang="less" scoped>
@import (reference) '~_acaAssets/wkce/colors/wkce-app-styles';

.merge-suggestion-notification {
    .ds1-ph-1();
    .ds1-mb-2();
    
    :deep(.utd-notification) {
        .ds1-mt-0();
    }
}

.merge-suggestion-notification__body {
    .ds1-ma-0();
    .ds1-mb-2();
}

.merge-suggestion-notification__actions {
    .ds1-mt-2();
    display: flex;
    gap: 8px;

    :deep(.utd-button) {
        background-color: @WKCE-GRAY-TINT5;
        color: @WKCE-BLACK;
    }
}
</style>
